import React, { useEffect, useReducer, useState } from "react";
import compoundInterestCalculatorFormActionTypes, {
    updateInputAction,
} from "../../actions/compound-interest-calculator-form.actions";
import CompoundInterestCalculatorFormReducer, {
    COMPOUND_INTEREST_CALCULATOR_FORM_INITIAL_STATE,
} from "../../reducers/compound-interest-calculator-form.reducer";
import { calculateCompoundInterest } from "../../utils/calculations";
import {
    isNumberInfinity,
    removeCommasFromNumber,
    separateNumberWithCommas,
    displayPercentInput,
} from "../../utils/numberDisplayManipulations.utils";
import PercentInputLabelContainer from "../percent-input-label-container/PercentInputLabelContainer";
// import { preventInvalidChars } from "../../utils/formValidations";
import CompoundInterestCalculatorNumberInput from "../compound-interest-calculator-number-input/CompoundInterestCalculatorNumberInput";
import "./compound-interest-calculator.styles.scss";
import CustomRadioButton from "../custom-radio-button/CustomRadioButton";
import InfoButton from "../info-button/InfoButton";

const CompoundInterestCalculator = () => {
    const [hasClickedExpandBtn, setHasClickedExpandBtn] = useState(false);
    const [displayAdditionalInputs, setDisplayAdditionalInputs] = useState(false);
    // const [hasExpandedAdditionalFutureValueOptions, setHasExpandedAdditionalFutureValueOptions] = useState(false);
    const [selectedOption, setSelectedOption] = useState("ללא מס");
    // const [tax, setTax] = useState(0);
    const [compoundInterestCalculatorFormState, dispatchCompoundInterestCalculatorFormState] = useReducer(
        CompoundInterestCalculatorFormReducer,
        COMPOUND_INTEREST_CALCULATOR_FORM_INITIAL_STATE
    );

    useEffect(() => {
        const compoundInterest = calculateCompoundInterest(
            compoundInterestCalculatorFormState.values.initialDepositAmount,
            compoundInterestCalculatorFormState.values.annualInterest,
            compoundInterestCalculatorFormState.values.periodOfInvestmentInYears,
            compoundInterestCalculatorFormState.values.monthlyDepositAmount,
            compoundInterestCalculatorFormState.values.managementFeePercentFromDeposit,
            compoundInterestCalculatorFormState.values.managementFeePercentFromTheAccrual,
            compoundInterestCalculatorFormState.values.tax
        );

        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_FUTURE_VALUE,
                // futureValue.futureValueSum,
                compoundInterest.compoundInterest,
                true,
                ""
            )
        );

        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_TOTAL_DEPOSIT_AMOUNT,
                compoundInterest.totalDeposits,
                true,
                ""
            )
        );

        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_TOTAL_MANAGEMENT_FEE_SUM_FROM_DEPOSIT,
                // futureValue.managementFeesDetails.totalManagementFeesFromDeposit,
                compoundInterest.totalManagementFeesFromDeposit,
                true,
                ""
            )
        );
        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_TOTAL_MANAGEMENT_FEE_SUM_FROM_THE_ACCRUAL,
                // futureValue.managementFeesDetails.totalManagementFeesFromTheAccrual,
                compoundInterest.totalManagementFeesFromAccrual,
                true,
                ""
            )
        );
        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_LOST_OF_PROFITS_FROM_MANAGEMENT_FEES,
                // futureValue.managementFeesDetails.lostOfProfitsFromManagementFees,
                compoundInterest.lostProfitsFromFees,
                true,
                ""
            )
        );
        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_PROFIT,
                compoundInterest.totalEarnings,
                true,
                ""
            )
        );
    }, [
        compoundInterestCalculatorFormState.values.initialDepositAmount,
        compoundInterestCalculatorFormState.values.monthlyDepositAmount,
        compoundInterestCalculatorFormState.values.annualInterest,
        compoundInterestCalculatorFormState.values.periodOfInvestmentInYears,
        compoundInterestCalculatorFormState.values.managementFeePercentFromDeposit,
        compoundInterestCalculatorFormState.values.managementFeePercentFromTheAccrual,
        compoundInterestCalculatorFormState.values.lostOfProfitsFromManagementFees,
        compoundInterestCalculatorFormState.values.tax,
    ]);

    const handleInitialDepositAmountOnChange = (e) => {
        const inputWithoutCommas = parseFloat(removeCommasFromNumber(e.target.value)) || 0;
        // const isValidInput = /^[0-9]*$/.test(inputWithoutCommas);

        // if (!isValidInput) {
        //     return dispatchCompoundInterestCalculatorFormState(
        //         updateInputAction(
        //             compoundInterestCalculatorFormActionTypes.UPDATE_INITIAL_DEPOSIT_AMOUNT,
        //             compoundInterestCalculatorFormState.values.initialDepositAmount,
        //             false,
        //             "שדה זה יכול להכיל ספרות בלבד"
        //         )
        //     );
        // }
        const maxNumberAllowed = 9999999999;

        if (inputWithoutCommas > maxNumberAllowed) {
            return dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_INITIAL_DEPOSIT_AMOUNT,
                    maxNumberAllowed,
                    false,
                    "מספר גדול מדי"
                )
            );
        }

        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_INITIAL_DEPOSIT_AMOUNT,
                inputWithoutCommas,
                true,
                ""
            )
        );
    };

    const handleMonthlyDepositAmountOnChange = (e) => {
        const inputWithoutCommas = parseFloat(removeCommasFromNumber(e.target.value)) || 0;
        // const isValidInput = /^[0-9]*$/.test(inputWithoutCommas);

        // if (!isValidInput) {
        //     return dispatchCompoundInterestCalculatorFormState(
        //         updateInputAction(
        //             compoundInterestCalculatorFormActionTypes.UPDATE_MONTHLY_DEPOSIT_AMOUNT,
        //             compoundInterestCalculatorFormState.values.monthlyDepositAmount,
        //             false,
        //             "שדה זה יכול להכיל ספרות בלבד"
        //         )
        //     );
        // }
        const maxNumberAllowed = 9999999999;

        if (inputWithoutCommas > maxNumberAllowed) {
            return dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_MONTHLY_DEPOSIT_AMOUNT,
                    maxNumberAllowed,
                    false,
                    "מספר גדול מדי"
                )
            );
        }

        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_MONTHLY_DEPOSIT_AMOUNT,
                inputWithoutCommas,
                true,
                ""
            )
        );
    };

    const handlePeriodOfInvestmentInYearsOnChange = (e) => {
        const input = parseInt(e.target.value) || 0;
        // const isValidInput = /^[0-9]*$/.test(input);
        const maxNumberAllowed = 120;
        const minNumberAllowed = 0;

        if (input > maxNumberAllowed || input < minNumberAllowed) {
            const periodOfInvestmentInYears = input > maxNumberAllowed ? maxNumberAllowed : minNumberAllowed;
            return dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_PERIOD_OF_INVESTMENT_IN_YEARS,
                    periodOfInvestmentInYears,
                    false,
                    "שדה זה יכול להכיל ספרות בלבד"
                )
            );
        }

        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_PERIOD_OF_INVESTMENT_IN_YEARS,
                input,
                true,
                ""
            )
        );
    };

    const handleAnnualInterestOnChange = (e) => {
        const input = parseFloat(e.target.value) || 0;
        const maxNumberAllowed = 1000;
        const minNumberAllowed = 0;

        if (input > maxNumberAllowed || input < minNumberAllowed) {
            const annualInterest = input > maxNumberAllowed ? maxNumberAllowed : minNumberAllowed;
            return dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_ANNUAL_INTEREST,
                    annualInterest,
                    false,
                    "אנא הכניסו מספר ריאלי"
                )
            );
        }

        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(compoundInterestCalculatorFormActionTypes.UPDATE_ANNUAL_INTEREST, input, true, "")
        );
    };

    const handleAnnualInterestOnKeyDown = (e, amountToAdd, amountToReduce) => {
        const parsedValue = parseFloat(compoundInterestCalculatorFormState.values.annualInterest) || 0;
        const maxNumberAllowed = 1000;
        const minNumberAllowed = 0;

        if (e.key === "ArrowUp") {
            if (parsedValue + amountToAdd > maxNumberAllowed) {
                return dispatchCompoundInterestCalculatorFormState(
                    updateInputAction(
                        compoundInterestCalculatorFormActionTypes.UPDATE_ANNUAL_INTEREST,
                        maxNumberAllowed,
                        false,
                        "המספר גדול מדי"
                    )
                );
            }

            dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_ANNUAL_INTEREST,
                    parsedValue + amountToAdd,
                    true,
                    ""
                )
            );
        } else if (e.key === "ArrowDown") {
            if (parsedValue - amountToReduce < minNumberAllowed) {
                return dispatchCompoundInterestCalculatorFormState(
                    updateInputAction(
                        compoundInterestCalculatorFormActionTypes.UPDATE_ANNUAL_INTEREST,
                        minNumberAllowed,
                        false,
                        "המספר קטן מדי"
                    )
                );
            }

            dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_ANNUAL_INTEREST,
                    parsedValue - amountToReduce,
                    true,
                    ""
                )
            );
        }
    };

    const handleAddButtonOnClick = (value, actionType, amountToAdd, maxNumberAllowed) => {
        const parsedValue = parseFloat(value) || 0;

        if (parsedValue + amountToAdd > maxNumberAllowed) {
            return dispatchCompoundInterestCalculatorFormState(
                updateInputAction(actionType, maxNumberAllowed, false, "המספר גדול מדי")
            );
        }

        dispatchCompoundInterestCalculatorFormState(updateInputAction(actionType, parsedValue + amountToAdd, true, ""));
    };

    const handleReduceButtonOnClick = (value, actionType, amountToReduce, minNumberAllowed) => {
        const parsedValue = parseFloat(value) || 0;

        if (parsedValue - amountToReduce < minNumberAllowed) {
            return dispatchCompoundInterestCalculatorFormState(
                updateInputAction(actionType, minNumberAllowed, false, "לא יכול להכיל מספרים שליליים")
            );
        }

        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(actionType, parsedValue - amountToReduce, true, "")
        );
    };

    const handleManagementFeePercentFromDepositOnChange = (e) => {
        const input = parseFloat(e.target.value) || 0;
        const maxNumberAllowed = 50;
        const minNumberAllowed = 0;

        if (input > maxNumberAllowed || input < minNumberAllowed) {
            const managementFeePercentFromDeposit = input > maxNumberAllowed ? maxNumberAllowed : minNumberAllowed;

            return dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_DEPOSIT,
                    managementFeePercentFromDeposit,
                    false,
                    "אנא הכניסו מספר ריאלי"
                )
            );
        }

        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_DEPOSIT,
                input,
                true,
                ""
            )
        );
    };

    const handleManagementFeePercentFromDepositOnKeyDown = (e, amountToAdd, amountToReduce) => {
        const parsedValue = parseFloat(compoundInterestCalculatorFormState.values.managementFeePercentFromDeposit) || 0;
        const maxNumberAllowed = 50;
        const minNumberAllowed = 0;

        if (e.key === "ArrowUp") {
            if (parsedValue + amountToAdd > maxNumberAllowed) {
                return dispatchCompoundInterestCalculatorFormState(
                    updateInputAction(
                        compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_DEPOSIT,
                        maxNumberAllowed,
                        false,
                        "המספר גדול מדי"
                    )
                );
            }

            dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_DEPOSIT,
                    parsedValue + amountToAdd,
                    true,
                    ""
                )
            );
        } else if (e.key === "ArrowDown") {
            if (parsedValue - amountToReduce < minNumberAllowed) {
                return dispatchCompoundInterestCalculatorFormState(
                    updateInputAction(
                        compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_DEPOSIT,
                        minNumberAllowed,
                        false,
                        "המספר קטן מדי"
                    )
                );
            }

            dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_DEPOSIT,
                    parsedValue - amountToReduce,
                    true,
                    ""
                )
            );
        }
    };

    const handleManagementFeePercentFromTheAccrualOnChange = (e) => {
        const input = parseFloat(e.target.value) || 0;
        const maxNumberAllowed = 50;
        const minNumberAllowed = 0;

        if (input > maxNumberAllowed || input < minNumberAllowed) {
            const managementFeePercentFromTheAccrual = input > maxNumberAllowed ? maxNumberAllowed : minNumberAllowed;

            return dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_THE_ACCRUAL,
                    managementFeePercentFromTheAccrual,
                    false,
                    "אנא הכניסו מספר ריאלי"
                )
            );
        }

        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_THE_ACCRUAL,
                input,
                true,
                ""
            )
        );
    };

    const handleManagementFeePercentFromTheAccrualOnKeyDown = (e, amountToAdd, amountToReduce) => {
        const parsedValue = parseFloat(compoundInterestCalculatorFormState.values.managementFeePercentFromTheAccrual) || 0;
        const maxNumberAllowed = 50;
        const minNumberAllowed = 0;

        if (e.key === "ArrowUp") {
            if (parsedValue + amountToAdd > maxNumberAllowed) {
                return dispatchCompoundInterestCalculatorFormState(
                    updateInputAction(
                        compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_THE_ACCRUAL,
                        maxNumberAllowed,
                        false,
                        "המספר גדול מדי"
                    )
                );
            }

            dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_THE_ACCRUAL,
                    parsedValue + amountToAdd,
                    true,
                    ""
                )
            );
        } else if (e.key === "ArrowDown") {
            if (parsedValue - amountToReduce < minNumberAllowed) {
                return dispatchCompoundInterestCalculatorFormState(
                    updateInputAction(
                        compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_THE_ACCRUAL,
                        minNumberAllowed,
                        false,
                        "המספר קטן מדי"
                    )
                );
            }

            dispatchCompoundInterestCalculatorFormState(
                updateInputAction(
                    compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_THE_ACCRUAL,
                    parsedValue - amountToReduce,
                    true,
                    ""
                )
            );
        }
    };

    const handleExpandButtonOnClick = (isExpanded) => {
        setDisplayAdditionalInputs(!displayAdditionalInputs);
        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_DEPOSIT,
                0,
                true,
                ""
            )
        );
        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(
                compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_THE_ACCRUAL,
                0,
                true,
                ""
            )
        );
    };

    const handleOptionChange = (value) => {
        setSelectedOption(value);
        const taxButton = document.querySelector(".tax-choice-btn");
        let tax = 0;
        let buttonLocationFromRight;
        switch (value) {
            case "tax0":
                tax = 0;
                buttonLocationFromRight = "0";
                break;
            case "tax15":
                tax = 0.15;
                buttonLocationFromRight = "33.33%";
                break;
            case "tax25":
                tax = 0.25;
                buttonLocationFromRight = "66.66%";
                break;

            default:
                break;
        }
        // console.log(tax);
        dispatchCompoundInterestCalculatorFormState(
            updateInputAction(compoundInterestCalculatorFormActionTypes.UPDATE_TAX, tax, true, "")
        );
        taxButton.style.right = buttonLocationFromRight;
    };

    const handleSmallerFontWhenOverflows = (mainClass, currentResult) => {
        const numberLength = Math.trunc(currentResult).toString().length;
        if (numberLength > 16) {
            return `${mainClass}--smallest-font`;
        }

        return mainClass;
    };

    return (
        <main className="compound-interest-calculator-container">
            <form className="compound-interest-calculator-form">
                <CompoundInterestCalculatorNumberInput
                    label={"סכום הפקדה ראשוני"}
                    value={separateNumberWithCommas(compoundInterestCalculatorFormState.values.initialDepositAmount)}
                    name="initial-deposit-amount"
                    onChange={handleInitialDepositAmountOnChange}
                    currency="₪"
                    infoText="כמה כסף אתם שוקלים להפקיד בהפקדה חד פעמית או כמה כסף מושקע כבר היום."
                />
                <CompoundInterestCalculatorNumberInput
                    label={"סכום הפקדה חודשי"}
                    value={separateNumberWithCommas(compoundInterestCalculatorFormState.values.monthlyDepositAmount)}
                    name="monthly-deposit-amount"
                    onChange={handleMonthlyDepositAmountOnChange}
                    currency="₪"
                    infoText="כמה כסף אתם שוקלים להפקיד כל חודש בהשקעה."
                />
                <CompoundInterestCalculatorNumberInput
                    label={"מספר שנות הפקדה"}
                    value={separateNumberWithCommas(
                        compoundInterestCalculatorFormState.values.periodOfInvestmentInYears
                    )}
                    name="period-of-investment-in-years"
                    onChange={handlePeriodOfInvestmentInYearsOnChange}
                    infoText="כמה שנים הכסף יוכל לעבוד עבורך מבלי להצטרך אותו."
                />
                <div
                    className={hasClickedExpandBtn ? "percent-inputs-container--expanded" : "percent-inputs-container"}
                >
                    <div
                        className={hasClickedExpandBtn ? "percent-inputs-wrapper--expanded" : "percent-inputs-wrapper"}
                    >
                        <PercentInputLabelContainer
                            value={displayPercentInput(compoundInterestCalculatorFormState.values.annualInterest)}
                            name={"annual-interest"}
                            label={"ריבית/תשואה שנתית"}
                            infoText='כמה תשואה או ריבית ההשקעה תניב בכל שנה באחוזים בממוצע: פיקדונות מפסידים כל שנה, קרן כספית 0%, הלוואות חברתיות 5%, נדל"ן להשקעה 7%, שוק ההון האמריקאי 9.3%, שוק ההון העולמי 9%, קריפטו 10%.'
                            onChange={handleAnnualInterestOnChange}
                            onKeyDown={(e) => {
                                handleAnnualInterestOnKeyDown(
                                    e,
                                    0.1,
                                    0.1
                                )
                            }}
                            addButtonOnClick={() => {
                                handleAddButtonOnClick(
                                    compoundInterestCalculatorFormState.values.annualInterest,
                                    compoundInterestCalculatorFormActionTypes.UPDATE_ANNUAL_INTEREST,
                                    0.1,
                                    1000
                                );
                            }}
                            reduceButtonOnClick={() => {
                                handleReduceButtonOnClick(
                                    compoundInterestCalculatorFormState.values.annualInterest,
                                    compoundInterestCalculatorFormActionTypes.UPDATE_ANNUAL_INTEREST,
                                    0.1,
                                    0
                                );
                            }}
                        />
                        {
                            /*displayAdditionalInputs && */ <div
                                className={
                                    displayAdditionalInputs
                                        ? "additional-percent-inputs-container--expanded"
                                        : "additional-percent-inputs-container"
                                }
                            >
                                <PercentInputLabelContainer
                                    value={displayPercentInput(
                                        compoundInterestCalculatorFormState.values.managementFeePercentFromDeposit
                                    )}
                                    name={"management-fees-from-deposit"}
                                    label={"דמי ניהול מהפקדה"}
                                    infoText="כמה כסף תשלמו כאחוז מסוים כל חודש מסך ההפקדה שלכם. דמי ניהול ממוצעים מהפקדה: 2% בקרנות פנסיה, 4% בביטוחי מנהלים, 0% בשאר המוצרים המנוהלים."
                                    onChange={handleManagementFeePercentFromDepositOnChange}
                                    onKeyDown={(e) => {
                                        handleManagementFeePercentFromDepositOnKeyDown(
                                            e,
                                            0.1,
                                            0.1
                                        )
                                    }}
                                    addButtonOnClick={() => {
                                        handleAddButtonOnClick(
                                            compoundInterestCalculatorFormState.values.managementFeePercentFromDeposit,
                                            compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_DEPOSIT,
                                            0.1,
                                            50
                                        );
                                    }}
                                    reduceButtonOnClick={() => {
                                        handleReduceButtonOnClick(
                                            compoundInterestCalculatorFormState.values.managementFeePercentFromDeposit,
                                            compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_DEPOSIT,
                                            0.1,
                                            0
                                        );
                                    }}
                                    isExpanded={displayAdditionalInputs}
                                    className={"additional-input__fee-from-deposit"}
                                />
                                <PercentInputLabelContainer
                                    value={displayPercentInput(
                                        compoundInterestCalculatorFormState.values.managementFeePercentFromTheAccrual
                                    )}
                                    name={"management-fees-from-the-accrual"}
                                    label={"דמי ניהול מצבירה"}
                                    infoText="כמה כסף תשלמו כל חודש בחלוקה שנתית מסך הכסף שצברתם בהשקעה משהתחלתם כולל ההפקדות והרווחים. דמי ניהול ממוצעים מצבירה: 0.15% בקרנות פנסיה, 0.5% בביטוחי מנהלים, 0.6% בקופות גמל קצבתיות, 0.6% בקרנות השתלמות, 0.7% בקופות גמל להשקעה ו-1% בפוליסות חיסכון להשקעה."
                                    onChange={handleManagementFeePercentFromTheAccrualOnChange}
                                    onKeyDown={(e) => {
                                        handleManagementFeePercentFromTheAccrualOnKeyDown(
                                            e,
                                            0.1,
                                            0.1
                                        )
                                    }}
                                    addButtonOnClick={() => {
                                        handleAddButtonOnClick(
                                            compoundInterestCalculatorFormState.values
                                                .managementFeePercentFromTheAccrual,
                                            compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_THE_ACCRUAL,
                                            0.1,
                                            50
                                        );
                                    }}
                                    reduceButtonOnClick={() => {
                                        handleReduceButtonOnClick(
                                            compoundInterestCalculatorFormState.values
                                                .managementFeePercentFromTheAccrual,
                                            compoundInterestCalculatorFormActionTypes.UPDATE_MANAGEMENT_FEE_PERCENT_FROM_THE_ACCRUAL,
                                            0.1,
                                            0
                                        );
                                    }}
                                    isExpanded={displayAdditionalInputs}
                                    className={"additional-input__fee-from-accrual"}
                                />
                            </div>
                        }
                    </div>

                    <div
                        className={
                            hasClickedExpandBtn
                                ? "expand-form-and-results-btn-container--expanded"
                                : "expand-form-and-results-btn-container"
                        }
                    >
                        <button
                            className="expand-form-and-results-btn"
                            type="button"
                            onClick={() => {
                                const expanded = !hasClickedExpandBtn;
                                setHasClickedExpandBtn(!hasClickedExpandBtn);
                                handleExpandButtonOnClick(expanded);
                            }}
                        >
                            <p>{hasClickedExpandBtn ? "הסתר דמי ניהול" : "לשיקלול דמי ניהול"}</p>
                            {/* </div> */}
                        </button>
                    </div>
                </div>
            </form>
            <section className="compound-interest-calculator-calculation-results">
                <div className="all-deposits-result-container">
                    <div
                        className={
                            (displayAdditionalInputs
                                ? "deposit-result-container--expanded"
                                : "deposit-result-container") + " deposit-result__total-deposit-sum-wrapper"
                        }
                    >
                        <InfoButton infoText="כמה סך הכל הפקדתם לאורך תקופת החיסכון (רק ההפקדה, ללא הרווחים)." />
                        <h3
                            className={handleSmallerFontWhenOverflows(
                                "deposit-result__title",
                                compoundInterestCalculatorFormState.values.totalDepositAmount
                            )}
                        >
                            סכום ההפקדה הכולל
                        </h3>
                        <span className="separator"></span>
                        <p
                            className={handleSmallerFontWhenOverflows(
                                "deposit-result-sum",
                                compoundInterestCalculatorFormState.values.totalDepositAmount
                            )}
                        >
                            {separateNumberWithCommas(compoundInterestCalculatorFormState.values.totalDepositAmount)}
                            {!isNumberInfinity(compoundInterestCalculatorFormState.values.totalDepositAmount) && (
                                <span>₪</span>
                            )}
                        </p>
                    </div>
                    <div
                        className={
                            displayAdditionalInputs
                                ? "total-management-fees-wrapper--expanded"
                                : "total-management-fees-wrapper"
                        }
                    >
                        <div className="total-management-fees-from-deposit-wrapper--expanded">
                            <div
                                className={
                                    displayAdditionalInputs
                                        ? "additional-inputs total-management-fees-from-deposit-container--expanded"
                                        : "additional-inputs total-management-fees-from-deposit-container"
                                }
                            >
                                <h3
                                    className={handleSmallerFontWhenOverflows(
                                        "deposit-result__title",
                                        compoundInterestCalculatorFormState.values.totalManagementFeeSumFromDeposit
                                    )}
                                >
                                    סך דמי ניהול מההפקדה
                                </h3>
                                {/* <span className="separator"></span> */}
                                <p
                                    className={handleSmallerFontWhenOverflows(
                                        "deposit-result-sum",
                                        compoundInterestCalculatorFormState.values.totalManagementFeeSumFromDeposit
                                    )}
                                >
                                    {separateNumberWithCommas(
                                        compoundInterestCalculatorFormState.values.totalManagementFeeSumFromDeposit
                                    )}
                                    {!isNumberInfinity(
                                        compoundInterestCalculatorFormState.values.totalManagementFeeSumFromDeposit
                                    ) && <span>₪</span>}
                                </p>
                            </div>
                            <div
                                className={
                                    displayAdditionalInputs
                                        ? "additional-inputs total-management-fees-from-the-accrual-container--expanded"
                                        : "additional-inputs total-management-fees-from-the-accrual-container"
                                }
                            >
                                <h3
                                    className={handleSmallerFontWhenOverflows(
                                        "deposit-result__title",
                                        compoundInterestCalculatorFormState.values.totalManagementFeeSumFromTheAccrual
                                    )}
                                >
                                    סך דמי ניהול מהצבירה
                                </h3>
                                {/* <span className="separator"></span> */}
                                <p
                                    className={handleSmallerFontWhenOverflows(
                                        "deposit-result-sum",
                                        compoundInterestCalculatorFormState.values.totalManagementFeeSumFromTheAccrual
                                    )}
                                >
                                    {separateNumberWithCommas(
                                        compoundInterestCalculatorFormState.values.totalManagementFeeSumFromTheAccrual
                                    )}
                                    {!isNumberInfinity(
                                        compoundInterestCalculatorFormState.values.totalManagementFeeSumFromTheAccrual
                                    ) && <span>₪</span>}
                                </p>
                            </div>
                        </div>

                        <div
                            className={
                                displayAdditionalInputs
                                    ? "lost-profits-from-fees-wrapper--expanded"
                                    : "lost-profits-from-fees-wrapper"
                            }
                        >
                            <div
                                className={
                                    displayAdditionalInputs
                                        ? "additional-inputs lost-profits-from-fees-container--expanded"
                                        : "additional-inputs lost-profits-from-fees-container"
                                }
                            >
                                <InfoButton infoText="סך הרווח שהיה יכול להיווצר במידה ולא היו גובים דמי ניהול." />
                                <h3 className={"lost-profits-from-fees__title"}>אובדן הרווח עקב דמי הניהול</h3>
                                <p className={"lost-profits-from-fees-result"}>
                                    {separateNumberWithCommas(
                                        compoundInterestCalculatorFormState.values.lostOfProfitsFromManagementFees
                                    )}
                                    {!isNumberInfinity(
                                        compoundInterestCalculatorFormState.values.lostOfProfitsFromManagementFees
                                    ) && <span>₪</span>}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="all-profits-container">
                    <div className="total-profits-result-container">
                        <InfoButton infoText="כמה רווח נצבר עבורכם בזכות תשואת ההשקעה + אפקט הריבית דריבית. (רק רווחים, לא כולל הפקדות.)" />
                        <h3 className={"total-profits-result__title"}>סך הרווח הכולל</h3>
                        <span className="separator"></span>
                        <p className={handleSmallerFontWhenOverflows("total-profits-result")}>
                            {separateNumberWithCommas(compoundInterestCalculatorFormState.values.profit)}
                            {!isNumberInfinity(compoundInterestCalculatorFormState.values.profit) && <span>₪</span>}
                        </p>
                    </div>
                </div>

                <div className="all-future-values-container">
                    <div className="net-future-value-container">
                        <InfoButton infoText="סך הכסף הכולל הפקדות + רווחים שנצברו עבורכם בסוף התקופה (ניתן לקזז את המס בעזרת הכפתורים למטה)." />
                        <h3 className="net-future-value__title">סך החיסכון העתידי</h3>
                        <span className="separator"></span>
                        <p
                            className={handleSmallerFontWhenOverflows(
                                "net-future-value",
                                compoundInterestCalculatorFormState.values.futureValue
                            )}
                        >
                            {separateNumberWithCommas(compoundInterestCalculatorFormState.values.futureValue)}
                            {!isNumberInfinity(compoundInterestCalculatorFormState.values.futureValue) && (
                                <span>₪</span>
                            )}
                        </p>
                    </div>
                    <div className="tax-radio-btn-container">
                        <CustomRadioButton
                            label="ללא מס"
                            name="tax"
                            value="tax0"
                            checked={selectedOption === "ללא מס"}
                            checkedValue={selectedOption}
                            onChange={handleOptionChange}
                            infoText={
                                'השקעה שאין לה חבות מס כמו לדוגמה: קרן פנסיה, קרן השתלמות לאחר 6 שנים, נכס נדל"ן יחיד שנמכר וקרן כספית החייבת ב 25% מס ריאלי (אין רווח ריאלי ולכן אין מס).'
                            }
                        />
                        <CustomRadioButton
                            label="15% מס"
                            name="tax"
                            value="tax15"
                            checked={selectedOption === "15% מס"}
                            checkedValue={selectedOption}
                            onChange={handleOptionChange}
                            infoText={
                                'השקעה שחייבת במס נומינלי (לפני השפעת האינפלציה) של 15% כמו לדוגמה: פיקדונות בבנק, ריבית מאג"ח, הלוואות חברתיות, עסקאות חוב והלוואות פרטיות.'
                            }
                        />
                        <CustomRadioButton
                            label="25% מס"
                            name="tax"
                            value="tax25"
                            checked={selectedOption === "25% מס"}
                            checkedValue={selectedOption}
                            onChange={handleOptionChange}
                            infoText={
                                'השקעה שחייבת במס ריאלי (אחרי השפעת האינפלציה) של 25%, כלומר רק על הרווח האמיתי אחרי ירידת ערך הכסף, כמו לדוגמה: רווח הון ממניות, דיבידנדים, רווח הון מאג"ח, השקעות אלטרנטיביות וקריפטו.'
                            }
                        />
                        <div className="tax-choice-btn"></div>
                    </div>
                </div>
            </section>
            {/* <span className="yars-signature">Created By yars</span> */}
        </main>
    );
};

export default CompoundInterestCalculator;
